import React from "react";
import AppTheme from "../../../../service/app_config/AppTheme";
import {  IconNormal } from "../../../../widget/common/ui/Icon";
import { ForwardChatContextImport } from "../../../../provider/chats/chats/forward_chat/ForwardChatContextProvider";

const ForwardChatActions = () => {
  const { showSearch, updateShowSearch } = ForwardChatContextImport();

  return (
    <>
      {!showSearch && (
        <IconNormal
          name="magnify"
          color={AppTheme.themeFont}
          handleClick={() => updateShowSearch()}
        />
      )}
    </>
  );
};

export default ForwardChatActions;
